import { Link } from "react-router-dom";
import { EU_COUNTRIES } from "@/constants/countries";

// EU 27 country marquee — clickable flags linking to /country/:slug
export default function CountryStrip() {
  const items = [...EU_COUNTRIES, ...EU_COUNTRIES];
  return (
    <section
      id="destinazioni"
      aria-label="I 27 Paesi d'Europa"
      className="bg-[#fafaf7] border-y border-[#e2e8f0] py-7 overflow-hidden"
    >
      <div className="marquee-track items-center">
        {items.map((c, i) => (
          <Link
            key={`${c.code}-${i}`}
            to={`/country/${c.slug}`}
            data-testid={`country-flag-${c.slug}`}
            className="px-7 md:px-10 flex items-center gap-8 md:gap-10 whitespace-nowrap group"
            title={c.name}
          >
            <img
              src={`https://flagcdn.com/64x48/${c.code}.png`}
              srcSet={`https://flagcdn.com/128x96/${c.code}.png 2x`}
              width="56"
              height="42"
              alt={c.name}
              loading="lazy"
              className="w-14 h-auto md:w-16 border border-[#e2e8f0] shadow-sm transition-transform duration-300 group-hover:scale-110 group-hover:shadow-md"
            />
            <span
              aria-hidden
              className="inline-block h-1 w-1 rounded-full bg-[#d4af37]"
            />
          </Link>
        ))}
      </div>
    </section>
  );
}
